import { OtoIndividualPlace } from '../../lib/types/models/journey-place/oto-individual-place'
import { OtoIndividualPlaceInput } from '../../lib/types/models/journey-place/oto-individual-place-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const updateOtoIndividualPlace = async (
  input: UpdateInput<OtoIndividualPlaceInput> & { journeyPlaceId: number }
) => {
  const { journeyPlaceId, id, ...data } = input

  return restApiClient
    .url(
      constructApiUrl(API.journeyPlaces.updateOtoIndividualPlace.url, {
        id: journeyPlaceId,
        otoIndividualPlaceId: id
      })
    )
    .patch<OtoIndividualPlace>(data)
}
